<template>
	<div>
		<div v-if="loggedInEmployee.isAdmin">
			<v-snackbar v-model="savedNotif" auto-height top>
				{{ savedNotifText }}
				<v-btn color="pink" flat @click="savedNotif = false"> Close </v-btn>
			</v-snackbar>

			<v-card class="mb-4">
				<meeting-locations-list :meeting-locations="meetingLocations" @onEdit="onEditMeetingLocation" @onDelete="onDeleteMeetingLocation"> </meeting-locations-list>

				<meeting-location-editor :dialog="meetingLocationEditorDialog" :title="meetingLocationEditorTitle" :meeting-location="editedMeetingLocation" @save="saveMeetingLocation" @closeEditor="meetingLocationEditorDialog = false">
				</meeting-location-editor>
			</v-card>

			<v-footer color="" app height="55">
				<v-spacer></v-spacer>
				<footer-add-btn @click="onAddMeetingLocation">Add Meeting Room</footer-add-btn>
			</v-footer>
		</div>
		<div v-else>You do not have access</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';

	import MeetingLocationsList from '@/components/settings/MeetingLocationsList';
	import MeetingLocationEditor from '@/components/settings/MeetingLocationEditor';

	export default {
		components: {
			MeetingLocationsList,
			MeetingLocationEditor
		},
		data() {
			return {
				meetingLocationEditorDialog: false,
				editedMeetingLocationIndex: -1,
				editedMeetingLocation: undefined,
				savedNotif: false,
				savedNotifText: null
			};
		},
		created() {
			this.$store.dispatch('setPageTitle', 'Meeting Rooms');
		},
		computed: {
			...mapGetters({
				meetingLocations: 'meetingLocations/meetingLocations',
				loggedInEmployee: 'loggedInEmployee'
			}),
			meetingLocationEditorTitle() {
				return this.editedMeetingLocationIndex === -1 ? 'New Meeting Room' : 'Edit Meeting Room';
			}
		},
		methods: {
			onEditMeetingLocation(meetingLocation) {
				this.editedMeetingLocationIndex = this.meetingLocations.indexOf(meetingLocation);
				this.editedMeetingLocation = Object.assign({}, meetingLocation);
				this.meetingLocationEditorDialog = true;
			},
			onDeleteMeetingLocation(meetingLocation) {
				const index = this.meetingLocations.indexOf(meetingLocation);
				if (confirm('Are you sure you want to delete this Meeting Room?')) {
					this.$store
						.dispatch('meetingLocations/delete', meetingLocation)
						.then(
							(response) => {
								this.savedNotifText = 'Meeting Room deleted';
							},
							(error) => {
								this.savedNotifText = 'Failed to delete Meeting Room';
								console.error('Error deleting Meeting Room');
							}
						)
						.finally(() => {
							this.savedNotif = true;
						});
				}
			},
			onAddMeetingLocation() {
				this.editedMeetingLocationIndex = -1;
				this.editedMeetingLocation = undefined;
				this.meetingLocationEditorDialog = true;
			},
			saveMeetingLocation(meetingLocation) {
				if (this.editedMeetingLocationIndex > -1) {
					this.$store
						.dispatch('meetingLocations/edit', meetingLocation)
						.then(
							(response) => {
								this.savedNotifText = 'Meeting Room saved';
							},
							(error) => {
								this.savedNotifText = 'Failed to save Meeting Room';
								console.error('Error saving Meeting Room');
							}
						)
						.finally(() => {
							this.savedNotif = true;
						});
				} else {
					this.$store
						.dispatch('meetingLocations/add', meetingLocation)
						.then(
							(response) => {
								this.savedNotifText = 'Meeting Room added';
							},
							(error) => {
								this.savedNotifText = 'Failed to add Meeting Room';
								console.error('Error saving Meeting Room');
							}
						)
						.finally(() => {
							this.savedNotif = true;
						});
				}
			}
		}
	};
</script>

<style></style>
